import { DisplayadData } from './displayad-data';
import { Component, OnInit } from '@angular/core';
import { RateserviceService } from '../services/rateservice.service';
import { AdRate } from '../adrate';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from '../Globals';

import { AdDataService } from '../services/addata.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AdbookingService } from '../services/adbooking.service';

class displayadModelinf {
  adcategory: any;
  choosedAd: any;
  customradio: any;
  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  adsize: any;
  adcost: any;
  gst: any;
  totalCost: any;
  imagename: File;
  adtype: any;
  adpage: string;
  flagupload: any;
  flagdate: any;
  noofdays: any;
  email: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;
  save: any;
  constructor() {
    this.adcategory = null;
    this.choosedAd = null;
    this.customradio = null;
    this.basicrate = null;
    this.widthinput = null;
    this.heightinput = null;
    this.adsizeinsqcm = null;
    this.save = null;
    this.adsize = null;
    this.adcost = null;

    this.gst = null;
    this.totalCost = null;
    this.imagename = null;
    this.adtype = null;
    this.adpage = null;
    this.flagupload = null;
    this.flagdate = null;
    this.noofdays = null;
    this.email = null;
    this.addate = null;
    this.trxnid = null;
    this.fileData = null;
    this.uploadedFilePath = null;
    this.selectedDate = null;
  }

}
@Component({
  selector: 'app-displayad',
  templateUrl: './displayad.component.html',
  styleUrls: ['./displayad.component.css'],
  providers: [Globals]
})
export class DisplayadComponent implements OnInit {
  // fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  // uploadedFilePath: string = null;
  displayadModel = {
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    gst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null,
    save: null,
  };
  adDetails = {
    adcategory: 'DisplayAd',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',
    touched: '',
    save: '',
  };
  id: number;
  adrate: AdRate = new AdRate();
  adCost: number;
  adSize: number;
  file: File;
  custom = 'one';
  buttonDisabled: boolean;
  filesize: number;
  //  heights = [
  //   '4',
  //   '5',
  //   '6',
  //   '7',
  //   '8',
  //   '9',
  //   '10',
  //   '11',
  //   '12',
  //   '13',
  //   '14',
  //   '15',
  //   '16',
  //   '17',
  //   '18',
  //   '19',
  //   '20',
  //   '21',
  //   '22',
  //   '23',
  //   '24',
  //   '25',
  //   '26',
  //   '27',
  //   '28',
  //   '29',
  //   '30',
  //   '31',
  //   '32',
  //   '33',
  //   '34',
  //   '35',
  //   '36',
  //   '37',
  //   '38',
  //   '39',
  //   '40',
  //   '41',
  //   '42',
  //   '43',
  //   '44',
  //   '45',
  //   '46',
  //   '47',
  //   '48',
  //   '49',
  //   '50',
    // "51",
    // "52"
  // ];
  widths = [
    '4',
    '8',
    '12',
    '16',
    '20',
    '24',
    '28',
    '33',

  ];
 checkedone: any = false;
  checkedtwo: any = false;
  quarterPageButton: any = false;
  halfPageButton: any = false;
  fullPageButton: any = false;
  adcustomButton: any = true;
  customradio3: any;
  customradio2: any;
  customradio1: any = true;
  colorrate1: number;
  colorrate2: number;
  rate: any;
  rate1: any;
  rate2: any;
  rate3: any;
  rate4: any;
  value: any;
  fileStatus: string;
  constructor(
    private http: HttpClient,
    private rateService: RateserviceService,
    private router: Router,
    private route: ActivatedRoute,
    public globals: Globals,
    private rateservice: RateserviceService,
    private addata: AdDataService,
    private adbookingservice: AdbookingService
  ) { }

  public options = [
    { value: 'Page 1', id: 'customradio1' },
    { value: 'Page 12', id: 'customradio2' },
    { value: 'InsidePages', id: 'Inside Pages' }
  ];

  ngOnInit() {

    this.basicrate();

    if (sessionStorage.getItem('Array')) {
      this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
      const obj = this.addata.getAdData();
      this.displayadModel = (obj) ? obj : this.adDetails;

      if (this.displayadModel.adtype === 'Black & White') {
        this.checkedone = true;

      } else if (this.displayadModel.adtype === 'Color') {

        this.checkedtwo = true;

      }

      if (this.displayadModel.adsize === 'full Page') {
        this.adcustomButton = false;
        this.quarterPageButton = false;
        this.halfPageButton = false;
        this.fullPageButton = true;
      } else if (this.displayadModel.adsize === 'Half Page') {
        this.adcustomButton = false;
        this.quarterPageButton = false;
        this.halfPageButton = true;
        this.fullPageButton = false;
      } else if (this.displayadModel.adsize === 'Quarter Page') {
        this.adcustomButton = false;
        this.quarterPageButton = true;
        this.halfPageButton = false;
        this.fullPageButton = false;
      } else {
        this.adcustomButton = true;
        this.quarterPageButton = false;
        this.halfPageButton = false;
        this.fullPageButton = false;
      }
    } else {
      this.displayadModel = this.adDetails;
    }

    // this.displayadModel.uploadbtn = JSON.parse(localStorage.getItem('uploadbtn'));

    this.globals.radio_flag = false;
    this.buttonDisabled = true;
    this.adrate = new AdRate();
    this.displayadModel.flagupload = false;


    /* To get Selected Component*/

    this.displayadModel.choosedAd = this.route.routeConfig.component.name;

  }



  callRateBw(val) {
    if (this.checkedone === true) {
      this.checkedone = true;
      this.checkedtwo = false;
    } else {
      this.checkedone = true;
      this.checkedtwo = false;
    }
    this.displayadModel.adpage = '';
    this.adDetails.adtype = val;
    this.displayadModel.adtype = val;
    const id = 1;
    this.displayadModel.customradio = 0;
    this.displayadModel.adcost = 0;
    this.rateService.getAdRateBw(id).subscribe(
      data => {
        this.adrate = data;
      },
      error => { console.log(error); }
    );
  }
  callRateColor(val) {
    if (this.checkedtwo === true) {
      this.checkedtwo = true;
      this.checkedone = false;
    } else {
      this.checkedtwo = true;
      this.checkedone = false;
    }
    this.displayadModel.adpage = '';
    this.adDetails.adtype = val;
    this.displayadModel.adtype = val;
    const id = 2;
    this.displayadModel.customradio = 0;
    this.displayadModel.adcost = 0;
    document.getElementById('others').style.visibility = 'hidden';

    this.rateService.getAdRateColor(id).subscribe(
      data => {
        this.adrate = data;
      },
      error => console.log(error)
    );
  }
  callRateFullPage(adrate: AdRate) {
    // this.globals.adCost = adrate.fullpage;
    // this.globals.adSize = "Full Page";
    this.displayadModel.adcost = adrate.fullpage;
    this.displayadModel.adsize = 'full Page';

    if (this.fullPageButton === false) {
      this.adcustomButton = false;
      this.quarterPageButton = false;
      this.halfPageButton = false;
      this.fullPageButton = true;
    }
  }

  callRateHalfPage(adrate: AdRate) {
    // this.globals.adCost = adrate.halfpage;
    this.displayadModel.adcost = adrate.halfpage;
    this.displayadModel.adsize = 'Half Page';
    // this.globals.adSize = "Half Page";
    if (this.halfPageButton === false) {
      this.adcustomButton = false;
      this.quarterPageButton = false;
      this.halfPageButton = true;
      this.fullPageButton = false;
    }
  }
  callRateQuarterPage(adrate: AdRate) {
    // this.globals.adCost = adrate.quarterpage;
    // this.globals.adSize = "Quarter Page";
    this.displayadModel.adcost = adrate.quarterpage;
    this.displayadModel.adsize = 'Quarter Page';
    if (this.quarterPageButton === false) {
      this.adcustomButton = false;
      this.quarterPageButton = true;
      this.halfPageButton = false;
      this.fullPageButton = false;
    }
  }

  callRateCustomPage(adrate: AdRate) {



    this.globals.adCost = 0;
    this.globals.adSize = '';
    this.displayadModel.adsizeinsqcm =
      this.displayadModel.widthinput * this.displayadModel.heightinput;
    this.displayadModel.adsize =
      this.displayadModel.widthinput +
      'cm Width * ' +
      this.displayadModel.heightinput +
      'cm Height';
    this.onItemchoose(0);
    if (this.adcustomButton === false) {
      this.adcustomButton = true;

    }
  }

  onItemChange(value: any) {
    if (value === 'First Page') {

      if (this.displayadModel.adtype === 'Black & White') {
        this.displayadModel.customradio = this.rate;

      } else if (this.displayadModel.adtype === 'Color') {

        this.displayadModel.customradio = this.rate3;

      }
      // this.displayadModel.customradio = '525';
      // console.log(this.displayadModel.customradio);
      // this.displayadModel.adpage = "First Page";
      // if (
      //   this.displayadModel.widthinput > 0 &&
      //   this.displayadModel.heightinput > 0
      // ) {
      //   this.displayadModel.adsize =
      //     this.displayadModel.widthinput +
      //     "cm Width * " +
      //     this.displayadModel.heightinput +
      //     "cm Height";
      //   this.displayadModel.adsizeinsqcm =
      //     this.displayadModel.widthinput * this.displayadModel.heightinput;

      //     console.log(this.displayadModel.adsizeinsqcm);
      //     console.log(this.displayadModel.customradio);
      //   this.displayadModel.adcost =
      //     this.displayadModel.adsizeinsqcm * 525;


      //     console.log(this.displayadModel.adcost);
      // }
    } else if (value === 'Last Page') {

      if (this.displayadModel.adtype === 'Black & White') {
        this.displayadModel.customradio = this.rate1;

      } else if (this.displayadModel.adtype === 'Color') {

        this.displayadModel.customradio = this.rate4;

      }
      // console.log(this.colorrate1);
      // this.displayadModel.customradio = '350';
      // this.displayadModel.adpage = " Last Page";
      // if (
      //   this.displayadModel.widthinput > 0 &&
      //   this.displayadModel.heightinput > 0
      // ) {
      //   this.displayadModel.adsize =
      //     this.displayadModel.widthinput +
      //     "cm Width * " +
      //     this.displayadModel.heightinput +
      //     "cm Height";
      //   this.displayadModel.adsizeinsqcm =
      //     this.displayadModel.widthinput * this.displayadModel.heightinput;
      //     console.log(this.displayadModel.adsizeinsqcm);

      //   this.displayadModel.adcost =
      //     this.displayadModel.adsizeinsqcm * 350;
      //     console.log(this.colorrate2);
      //      console.log(this.displayadModel.adcost);
      //    this.globals.adSize = 4 * this.globals.adcustom_size;
      //    this.globals.adCost = this.globals.adSize * this.globals.adRate;
      // }
    } else if (value === 'Inside Pages') {
      // this.globals.adRate = this.adrate.pagebetween;
      this.displayadModel.customradio = this.rate2;
      // this.displayadModel.adpage = "Inside Pages";
      // if (
      //   this.displayadModel.widthinput > 0 &&
      //   this.displayadModel.heightinput > 0
      // ) {
      //   this.displayadModel.adsize =
      //     this.displayadModel.widthinput +
      //     " cm Width * " +
      //     this.displayadModel.heightinput +
      //     "cm Height";
      //   this.displayadModel.adsizeinsqcm =
      //     this.displayadModel.widthinput * this.displayadModel.heightinput;
      //   this.displayadModel.adcost =
      //     this.displayadModel.adsizeinsqcm * 210;
      //    this.globals.adSize = 4 * this.globals.adcustom_size;
      //    this.globals.adCost = this.globals.adSize * this.globals.adRate;
      // }
    }
    // this.globals.radio_flag = true;
    // this.buttonDisabled = false;
    this.displayadModel.adsizeinsqcm =
      this.displayadModel.widthinput * this.displayadModel.heightinput;
    this.displayadModel.adsize =
      this.displayadModel.widthinput +
      'cm Wd. * ' +
      this.displayadModel.heightinput +
      'cm Lt.';
    // this.displayadModel.adcost =
    //   this.displayadModel.adsizeinsqcm * this.displayadModel.customradio;

    this.displayadModel.adcost =
      (this.displayadModel.adsizeinsqcm * this.displayadModel.customradio).toFixed(2);
  }

  onSearchChange(): void {
    // this.globals.adcustom_size = searchValue;
    this.displayadModel.adsizeinsqcm =
      this.displayadModel.widthinput * this.displayadModel.heightinput;
    this.displayadModel.adsize =
      this.displayadModel.widthinput +
      'cm Wd. * ' +
      this.displayadModel.heightinput +
      'cm Lt.';
    // this.displayadModel.adcost =
    //   this.displayadModel.adsizeinsqcm * this.displayadModel.customradio;

    this.displayadModel.adcost =
      (this.displayadModel.adsizeinsqcm * this.displayadModel.customradio).toFixed(2);
    // this.globals.adSize = 4 * this.globals.adcustom_size;
    //  this.globals.adCost = this.globals.adSize * this.globals.adRate;
  }

  // readFile(fileEvent: any) {
  //   const file = fileEvent.target.files;
  //   this.globals.fileSize = file.size;
  //   this.displayadModel.uploadbtn = file;
  /* if (file.size > 2048576)  // validation according to file size
  {
    document.getElementById("errorName5").innerHTML = "Image size too short";
    console.log('type', file.type);
  } */
  // }
  fileProgress(fileInput: any) {
    {
      const ext = this.displayadModel.imagename.match(/\.([^\.]+)$/)[1];
      switch (ext) {
        case 'pdf':
        case 'eps':
        case 'tiff':
          case 'tiff':
            this.fileStatus = '*Saved Successfully';
            break;
          default:
            this.fileStatus = '*File Format Not Supported';
            this.displayadModel.imagename = '';

      }

      //  console.log(this.displayadModel.adpage);
      this.displayadModel.flagdate = false;
      this.displayadModel.fileData = fileInput.target.files[0] as File;

      sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));
      //  this.preview();
      console.log(this.displayadModel);
    }
  }

  // preview() {
  //   // Show preview
  //   var mimeType = this.displayadModel.fileData.type;
  //   if (mimeType.match(/image\/*/) === null) {
  //     return;
  //   }

  //   var reader = new FileReader();
  //   reader.readAsDataURL(this.displayadModel.fileData);
  //   reader.onload = _event => {
  //     this.previewUrl = reader.result;
  //   };
  // }

  onItemchoose(value: any) {

    // this.displayadModel.adsizeinsqcm =
    //   this.displayadModel.widthinput * this.displayadModel.heightinput;
    // this.displayadModel.adsize =
    //   this.displayadModel.widthinput +
    //   "cm Width * " +
    //   this.displayadModel.heightinput +
    //   "cm Height";
    this.displayadModel.adcost =
      (this.displayadModel.adsizeinsqcm * this.displayadModel.customradio).toFixed(2);



  }


  basicrate() {

    this.rateservice.getAdRate('displayAd').subscribe(
      data => {
        //  this.adcost = data;
        //  console.log(this.adcost);
        if (Array.isArray(data) && data.length) {
          const baserate = data[''];
          const resource = data[0];
          this.rate = (resource.adcost);
          const resource1 = data[1];
          this.rate1 = (resource1.adcost);
          const resource2 = data[2];
          this.rate2 = (resource2.adcost);
          const resource3 = data[3];
          this.rate3 = (resource3.adcost);
          const resource4 = data[4];
          this.rate4 = (resource4.adcost);
        }
      });
  }



  //   onSubmit() {
  //     const formData = new FormData();
  //     console.log(this.fileData);
  //     formData.append('files', this.fileData);
  //     this.displayadModel.flagdate = false;
  //     this.fileUploadProgress = '0%';
  //     this.http.post('https://us-central1-tutorial-e6ea7.cloudfunctions.net/fileUpload', formData, {
  //     reportProgress: true,
  //     observe: 'events'
  //     })
  //     .subscribe(events =>
  //       if(events.type === HttpEventType.UploadProgress) {
  //         this.fileUploadProgress = Math.round(events.loaded / events.total * 100) + '%';
  //         console.log(this.fileUploadProgress);
  //       } else if(events.type === HttpEventType.Response) {
  //         this.fileUploadProgress = '';
  //         console.log(events.body);
  //         alert('SUCCESS !!');

  //       }

  //     })
  // }
  fileSave() {
    const file = this.displayadModel.fileData;
    this.adbookingservice.savefile(file, null).subscribe(data => {
      console.log(data);

    });



  }

  onFormSubmit() {
    this.displayadModel.imagename = this.displayadModel.fileData.name;
    // alert(this.displayadModel.imagename)

    sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

    let obj = this.addata.getAdData();
    obj = this.displayadModel;
    this.addata.setAdData(obj);
  }
}
